import React from "react";
import Helmet from "react-helmet";

import Tags from "../components/Tags/index.jsx";
// Import EmailForm from "./../components/EmailForm/index.jsx";
import Time from "../components/Time/index.jsx";
import PrevNextNav from "../components/PrevNextNav/index.jsx";
import JsonLDArticle from "../components/JsonLD/article.jsx";

import "./blog-post.css";
require("prismjs/themes/prism.css");
// Import "./prism.css";
import "./prism-tomorrow.css";
// Require("prismjs/themes/prism-okaidia.css");

export default function Template({
	// eslint-disable-next-line react/prop-types
	data,
	// eslint-disable-next-line react/prop-types
	pathContext
}) {
	// Data.markdownRemark xholds our post data
	const { site, markdownRemark } = data,
		{ excerpt, frontmatter, html } = markdownRemark,
		{ social, siteUrl, title } = site.siteMetadata,
		featuredImage = frontmatter.cover.childImageSharp.sizes.src,
		{ next, prev } = pathContext,
		extractHandle = url => {
			const parts = url.split("/");

			return parts[parts.length - 1];
		},
		twitterHandle = extractHandle(social.twitter);

	return (
		<article className="blog-post-container container">
			<Helmet
				title={`${frontmatter.title} | Andrew Griffiths`}
				meta={[
					{
						name: "description",
						content: excerpt
					},

					/*
					 * https://github.com/Vagr9K/gatsby-advanced-starter/blob/cbb1f8572de1c362fd286a4b04a23dc8781b1160/src/components/SEO/SEO.jsx
					 * facebook
					 */
					{
						name: "og:url",
						content: `${siteUrl}${frontmatter.path}`
					},
					{
						name: "og:site_name",
						content: title
					},
					{
						name: "og:type",
						content: "article"
					},
					{
						name: "og:title",
						content: frontmatter.title
					},
					{
						name: "og:description",
						content: excerpt
					},
					{
						name: "og:image",
						content: `${siteUrl}${featuredImage}`
					},
					// Twitter
					{
						name: "twitter:card",
						content: "summary_large_image"
					},
					{
						name: "twitter:title",
						content: frontmatter.title
					},
					{
						name: "twitter:description",
						content: excerpt
					},
					{
						name: "twitter:creator",
						content: `@${twitterHandle}`
					},
					{
						name: "twitter:image",
						content: `${siteUrl}${featuredImage}`
					}
				]}
			/>
			<section>
				<h1>{frontmatter.title}</h1>
				<Time date={frontmatter.date} />
				<div
					className="post-content"
					dangerouslySetInnerHTML={{ __html: html }}
				/>
				<JsonLDArticle
					articleData={frontmatter}
					description={excerpt}
					siteMetadata={site.siteMetadata}
					featuredImage={featuredImage}
				/>
				<Tags list={frontmatter.tags || []} />
				<PrevNextNav prev={prev} next={next} />
			</section>
		</article>
	);
}

// FeaturedImage {
export const pageQuery = graphql`
	query BlogPostByPath($path: String!) {
		site {
			siteMetadata {
				siteUrl
				social {
					twitter
					linkedin
					github
				}
				title
			}
		}
		markdownRemark(frontmatter: { path: { eq: $path } }) {
			html
			excerpt
			frontmatter {
				author
				cover {
					childImageSharp {
						sizes(maxWidth: 1800) {
							...GatsbyImageSharpSizes
						}
					}
				}
				date(formatString: "DD MMMM, YYYY")
				path
				tags
				title
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/templates/blog-post.js